import { XCircleIcon } from "@heroicons/react/16/solid";
import React, { useEffect, useRef, useState } from "react";
import { USER } from "../../types/user";
import messages from "../../constants/Messages";

interface DuplicateUserModalProps {
  title: string;
  isOpen: boolean;
  type: string;
  onClose: () => void;
  onCreateUser: (e) => void;
  onUpdateUser: (e, userID) => void;
  duplicateUsers: USER[];
  showEditOptions?: boolean;
}

const DuplicateUserModal: React.FC<DuplicateUserModalProps> = ({
  title,
  isOpen,
  type,
  onCreateUser,
  onUpdateUser,
  onClose,
  duplicateUsers,
  showEditOptions = true,
}) => {
  let options: string[] = [];
  if (showEditOptions) {
    options = ["入力した内容で更新する", "入力した内容で新規作成する"];
  } else {
    options = ["入力した内容で新規作成する"];
  }

  const [selectedOption, setSelectedOption] = useState<string>(options[0]);
  const [selectedUser, setselectedUser] = useState<number>(
    duplicateUsers[0]?.id || 0,
  );
  const [showDuplicateUsers, setShowDuplicateUsers] = useState<boolean>(false);

  useEffect(() => {
    setselectedUser(duplicateUsers[0]?.id || 0);
  }, [duplicateUsers]);

  const handleDoAction = (e) => {
    if (!showEditOptions) {
      onCreateUser(e);
      onClose();
      return;
    }

    if (selectedOption === options[0]) {
      setShowDuplicateUsers(true);
    } else {
      onCreateUser(e);
      onClose();
    }
  };

  const handleDoUserAction = (e) => {
    if (selectedOption == options[0]) {
      onUpdateUser(e, selectedUser);
    }
  };

  const resetModal = () => {
    setShowDuplicateUsers(false);
    setSelectedOption(options[0]);
    setselectedUser(0);
  };

  const handleClose = () => {
    resetModal();
    onClose();
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (!showDuplicateUsers) {
      handleDoAction(e);
    } else {
      handleDoUserAction(e);
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center backdrop-brightness-50 z-[1000]">
      <div className="bg-white border border-text-field-border rounded-lg w-[90vw] sm:w-[80vw] md:w-[60vw] lg:w-[40vw] xl:w-[40vw] max-w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="mayo-card-header p-4 flex justify-between items-center">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button onClick={onClose} className="text-xl hover:opacity-50">
            <svg
              className="ml-2 fill-body hover:fill-primary"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <XCircleIcon />
            </svg>
          </button>
        </div>

        {!showDuplicateUsers ? (
          <div className="space-y-2">
            {options?.map((option, index) => (
              <label
                key={index}
                className="ml-4 mt-4 flex items-center space-x-2"
              >
                <input
                  type="radio"
                  name="contentType"
                  value={option}
                  defaultValue={option[0]}
                  checked={selectedOption === option}
                  onChange={() => setSelectedOption(option)}
                  className="accent-blue-500"
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        ) : (
          <div className="space-y-2">
            <div>
              <p className="mt-2 flex items-center justify-center text-md">
                {messages.user.duplicate_select}
              </p>
              {duplicateUsers?.map((user, index) => (
                <label
                  key={index}
                  className="ml-4 mt-4 flex items-center space-x-2"
                >
                  <input
                    type="radio"
                    name="contentType"
                    defaultValue={`${duplicateUsers[0].last_name} ${duplicateUsers[0].first_name}`}
                    value={`${user.last_name} ${user.first_name}`}
                    checked={selectedUser === user.id}
                    onChange={() => setselectedUser(user.id)}
                    className="accent-blue-500"
                  />
                  <span className="whitespace-pre">
                    {`${user.last_name} ${user.first_name} ${
                      user.email || ""
                    } \n${user.personal_tel ? `${user.personal_tel}` : ""}${
                      user.personal_tel && user.company_tel ? " / " : ""
                    }${user.company_tel ? `${user.company_tel}` : ""}`}
                  </span>
                </label>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-end gap-2.5 mt-2 mb-5 mr-4">
          <button
            onClick={handleClose}
            className="button-small-white border-text-field-border"
          >
            {"キャンセル"}
          </button>
          <button
            onClick={handleClick}
            className={`button-small-white border-text-field-border`}
          >
            決定
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateUserModal;
